// extracted by mini-css-extract-plugin
export default {"fadeInFromRight":"PageFade_fadeInFromRight__oDPMp","fadeInFromLeft":"PageFade_fadeInFromLeft__EInzJ"};